/* eslint-disable prettier/prettier */

import axios from "axios";
import cc from "@/js/commonData.js";

export default {
  async getSession() {
    const response = await axios({
      method: "post",
      url: cc.getDomain() + "/check_session.php",
      withCredentials: true,
    });

    // 서버 응답 확인
    // console.log("응답 데이터:", response);

    //세션이 없는 경우, res_status가 0이면 세션이 존재하지 않음, 1이면 유효
    if (response["data"]["res_status"] == "0") {
      return { id: "-1" };
      //반환값은 단순 문자열, 클라이언트가 이를 JSON 객체로 인식하지 않음
      //return '{"id":"-1"}';
    }
    return response["data"]["res_userData"];
  },
  async logOut() {
    const response = await axios({
      method: "post",
      url: cc.getDomain() + "/user_logout.php",
      withCredentials: true,
    });

    // 서버 응답 확인
    // console.log("응답 데이터:", response);

    if (response["data"]["res_status"] == "1") {
      // console.log("로그아웃 성공");
    }
  },
};
